import { render, staticRenderFns } from "./modal-watsons-branch.vue?vue&type=template&id=7b626624"
import script from "./modal-watsons-branch.vue?vue&type=script&lang=js"
export * from "./modal-watsons-branch.vue?vue&type=script&lang=js"
import style0 from "./modal-watsons-branch.vue?vue&type=style&index=0&id=7b626624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports